import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

import { MathEnabledTextComponent, styleVariables } from '@lib/common';
import { styled } from '@xstyled/styled-components';
import { Space } from 'antd';
import { QuestionTagComponent } from '../../question-tag';
import { useMemo } from 'react';
import { isManuallyAwardedAnswer } from '../../utils/get-answer-grading-visual-status';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var QuestionCard = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n  width: 100%;\n  border-radius: 8px;\n  box-shadow: ", ";\n  background-color: ", ";\n  border: ", ";\n"])), function (props) {
  var theme = props.theme;

  if (theme.media.isMobile) {
    return 0;
  }

  return '32px 40px';
}, function (props) {
  var theme = props.theme;

  if (theme.media.isMobile) {
    return 'none';
  }

  return "0px 3px 6px rgba(0, 0, 0, 0.12)";
}, function (props) {
  var theme = props.theme;

  if (theme.media.isMobile) {
    return 'transparent';
  }

  return styleVariables.colors.gray1;
}, function (props) {
  var isSkipped = props.isSkipped,
      isEssayQuestion = props.isEssayQuestion,
      isCorrect = props.isCorrect,
      theme = props.theme,
      isCorrectAnswerMissing = props.isCorrectAnswerMissing,
      isManuallyAwarded = props.isManuallyAwarded;

  if (theme.media.isMobile) {
    return 0;
  }

  if (isSkipped) {
    return "1px solid ".concat(styleVariables.colors.red3);
  }

  if (isEssayQuestion || isCorrectAnswerMissing) {
    return "1px solid ".concat(styleVariables.colors.blue2);
  }

  if (isCorrect) {
    return "1px solid ".concat(styleVariables.colors.green1);
  }

  if (isManuallyAwarded) {
    return "1px solid ".concat(styleVariables.colors.gold1);
  }

  return "1px solid ".concat(styleVariables.colors.red3);
});
var QuestionContent = styled(MathEnabledTextComponent)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n\n  p {\n    margin: 0;\n  }\n  img {\n    max-width: 100%;\n  }\n"])), styleVariables.colors.gray13);
var Content = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
var ExplanationArea = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-radius: 8px;\n  padding: 16px;\n\n  background-color: ", ";\n"])), styleVariables.colors.gray3);
var ExplanationTitle = styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n\n  color: ", ";\n"])), styleVariables.colors.gray13);
var ExplanationContent = styled(MathEnabledTextComponent)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n\n  color: ", ";\n\n  p {\n    margin: 0;\n  }\n"])), styleVariables.colors.gray13);
var Title = styled.label(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 24px;\n\n  color: ", ";\n"])), styleVariables.colors.gray13);
var TitleArea = styled(Space)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral([""])));
var StyledHeaderArea = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var StyledScore = styled.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: ", ";\n"])), styleVariables.colors.gray10);
export var SubmissionBaseQuestionPreview = function SubmissionBaseQuestionPreview(props) {
  var question = props.question,
      index = props.index,
      isSkipped = props.isSkipped,
      isEssayQuestion = props.isEssayQuestion,
      isCorrect = props.isCorrect,
      score = props.score,
      hasGraded = props.hasGraded,
      isShowingExplanation = props.isShowingExplanation,
      label = props.label,
      children = props.children,
      isCorrectAnswerMissing = props.isCorrectAnswerMissing,
      hideScore = props.hideScore;
  var questionTypeTagLabel = useMemo(function () {
    return {
      fillInBlankQuestion: label.fillInBlankQuestion,
      matchingQuestion: label.matchingQuestion,
      essayQuestion: label.essayQuestion,
      multipleChoiceQuestion: label.matchingQuestion,
      skipped: label.skipped,
      correct: label.correct,
      inCorrect: label.inCorrect || 'Incorrect'
    };
  }, [label]);
  var isManuallyAwarded = isManuallyAwardedAnswer({
    isCorrect: isCorrect,
    score: score,
    hasGraded: hasGraded
  });
  var defaultShowingExplanationStatus = useMemo(function () {
    return isShowingExplanation !== null && isShowingExplanation !== void 0 ? isShowingExplanation : true;
  }, [isShowingExplanation]);

  var renderExplanation = function renderExplanation() {
    if (question.explanation === undefined) {
      return;
    }

    var isEmptyExplanation = question.explanation === '';
    var defaultExplanationContent = isEmptyExplanation ? /*#__PURE__*/_jsxs("i", {
      children: ["(", label.notHaveExplanationForThisQuestion, ")"]
    }) : /*#__PURE__*/_jsx(ExplanationContent, {
      value: question.explanation
    });
    return defaultShowingExplanationStatus && /*#__PURE__*/_jsxs(ExplanationArea, {
      children: [/*#__PURE__*/_jsx(ExplanationTitle, {
        children: label.explanation
      }), defaultExplanationContent]
    });
  };

  return /*#__PURE__*/_jsxs(QuestionCard, {
    isSkipped: isSkipped,
    isEssayQuestion: isEssayQuestion,
    isCorrect: isCorrect,
    isManuallyAwarded: isManuallyAwarded,
    isCorrectAnswerMissing: isCorrectAnswerMissing,
    direction: "vertical",
    size: "middle",
    children: [/*#__PURE__*/_jsxs(StyledHeaderArea, {
      children: [/*#__PURE__*/_jsxs(TitleArea, {
        children: [/*#__PURE__*/_jsxs(Title, {
          children: [label.question, " ", question.titleIndex]
        }), /*#__PURE__*/_jsx(QuestionTagComponent, {
          question: question,
          isSkipped: isSkipped,
          isCorrect: isCorrect,
          hasAnswer: !isSkipped,
          score: score,
          hasGraded: hasGraded,
          label: questionTypeTagLabel
        })]
      }), !hideScore && /*#__PURE__*/_jsxs(StyledScore, {
        children: [question.score, " ", label.score]
      })]
    }), /*#__PURE__*/_jsx(QuestionContent, {
      value: question.description
    }), /*#__PURE__*/_jsx(Content, {
      children: children
    }), renderExplanation()]
  });
};